import { render } from "./CampaignMenu.vue?vue&type=template&id=0278fc8d&scoped=true"
import script from "./CampaignMenu.vue?vue&type=script&lang=js"
export * from "./CampaignMenu.vue?vue&type=script&lang=js"

import "./CampaignMenu.vue?vue&type=style&index=0&id=0278fc8d&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0278fc8d"]])

export default __exports__